import type { FileTransmissionError, IFileTransmissionProgressListener } from '@core/FileTransmissionProgressListener'
import type { TaskInfo } from '@core/transmission/ITask'
import { TaskError, TransmissionTaskType } from '@core/transmission/ITask'
import { AbsTask } from '@core/transmission/AbsTask'
import type { Listener } from './IReadOnlyFileTransmissionManager'

/**
 * 上传文件任务
 */
export class AbsUploadTask extends AbsTask {
  protected _targetPath: string
  protected _file: File | null
  protected _progressListener: IFileTransmissionProgressListener
  protected _relativePath = ''
  protected _fileUploadListener: Listener | undefined
  protected _transmissionTaskType: TransmissionTaskType = TransmissionTaskType.UPLOAD

  constructor(
    deviceId: string,
    targetPath: string,
    file: File,
    isViaLan: boolean,
    relativePath: string,
    appId: string
  ) {
    super(deviceId, isViaLan, appId)
    this._targetPath = targetPath
    this._file = file
    this._fileName = this._file.name
    this._fileSize = this._file.size
    this._noticeId = ''
    this._relativePath = relativePath
    this._progressListener = {
      onStart: (id) => {
        if (this.isDeleted) return
        this.onStart(id)
      },
      onProgressChanged: (transmitted, total) => {
        if (this.isDeleted) return
        this.onProgressChanged(transmitted, total)
      },
      onCompleted: (fileId?) => {
        if (this.isDeleted) return
        this.onCompleted(fileId)
      },
      onCancelled: (isRemote: boolean) => {
        if (this.isDeleted) return
        this.onCancelled(isRemote)
      },
      onError: (error) => {
        if (this.isDeleted) return
        this.onError(error)
      },
    }
  }

  cleanUpUnusedData() {
    this._file = null
  }

  onStart(id: string): void {
    throw new Error('Method not implemented.')
  }

  onProgressChanged(transmitted: number, total: number): void {
    throw new Error('Method not implemented.')
  }

  onCompleted(fileId?: string | undefined): void {
    throw new Error('Method not implemented.')
  }

  onCancelled(isRemote: boolean | undefined): void {
    if (isRemote) {
      this._failedReason = TaskError.SERVER_REMOTE_CANCEL
      this._taskScheduler?.setTaskError(this)
    }
  }

  onError(error: FileTransmissionError): void {
    this._failedReason = TaskError.TRANSFER_FAILED
    this._handleError(error)
  }

  setUploadListener(listener: Listener) {
    this._fileUploadListener = listener
  }

  removeUploadListener() {
    this._taskScheduler = undefined
  }

  toJson(): TaskInfo {
    return {
      ...super.toJson(),
      relativePath: this._relativePath,
      targetPath: this._targetPath,
      deviceId: this._deviceId,
      completionRatio: this._getCompletionRation(),
    }
  }

  protected _handleError(error: unknown): void {
    this._requestCancelToken = undefined
    this.canChangeState = true
    this._taskScheduler?.setTaskError(this)
    this._fileUploadListener?.onError(this._deviceId, this._targetPath, this._fileName, this.failedReason as string)
    //TODO error 信息暂无定义
    console.log(`[Transmission] ${new Date().toLocaleString()} `, '_handleError:', error, this.failedReason)
  }
}
